// extracted by mini-css-extract-plugin
export default {"productGrid":"M0-z","centerLink":"N0-z","productSection":"O0-z","item":"P0-z","ctaButton":"Q0-z"};